import { useIntl } from 'react-intl';
import { Button } from '@hqo/ui-atoms';
import { Modal } from 'components/shared/modal/modal';

interface VisitDetailsModalStateProps {
  onClose: VoidFunction;
}

/**
 * Shown when the visit cannot be read.
 *
 * Reached almost exclusively by deeplink, which is the one entry point where the id can be stale, belong
 * to another building, or have been purged. The fetch failure is otherwise silent — the modal simply
 * never opens and the user is left on a list they did not ask for, with nothing to explain it.
 */
export const VisitDetailsNotFound = ({ onClose }: VisitDetailsModalStateProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <Modal onClose={onClose} variant="normal" withExitButton marginTop="100px">
      <div className="flex flex-col items-center w-full pt-6 text-center" data-testid="visit-details-not-found">
        <h2 className="text-2xl font-semibold m-0 text-gray-900 mb-3">
          {formatMessage({
            id: 'notifications.criticalErrors.default.title',
            defaultMessage: 'Something went wrong',
          })}
        </h2>
        <p className="text-sm text-gray-500 m-0 mb-8">
          {formatMessage({
            id: 'notifications.criticalErrors.default.description',
            defaultMessage: 'An unexpected error occurred. Please try again later.',
          })}
        </p>
        <Button className="w-full" onClick={onClose} data-cy="back-to-visits">
          {formatMessage({ id: 'button.backToVisits', defaultMessage: 'Back to visits' })}
        </Button>
      </div>
    </Modal>
  );
};
